<script setup lang="ts">
  import Photos from './Photos.vue'
  import Videos from './Videos.vue'
  import Lives from './Lives.vue'
  import PerfilDescription from './PerfilDescription.vue'
  import ModelWallpapers from './ModelWallpapers.vue'
  import ModelCredits from './ModelCredits.vue'
  import BannerAssineHorizontal from 'components/HomePage/BannerAssineHorizontal.vue'
  import ModalSubscribePlans from 'components/Modais/ModalSubscribePlansAndCredits.vue'
  import Loading from 'vue-loading-overlay'
  import VideosNotSubscribe from './VideosNotSubscribe.vue'
  import LivesNotSubscribe from './LivesNotSubscribe.vue'
</script>
<template>
  <div class="navbar-header-model">
    <loading v-model:active="loading" :is-full-page="false" color="#b20000" />
    <tabs
      v-model="selectedTab"
      :options="{
        useUrlFragment: true,
        disableScrollBehavior: true,
        defaultTabHash: 'model-tabs-individual'
      }"
      @update:modelValue="changeUrlTab"
    >
      <tab
        v-for="(tab, i) in tabsHeader"
        :key="`t${i}`"
        :val="tab.val"
        :label="tab.name"
        :indicator="true"
      />
    </tabs>
    <tab-panels v-model="selectedTab" :animate="true" :swipeable="false">
      <tab-panel :key="`tp0`" :val="1">
        <Photos
          :model="dataModel"
          :translate="translate"
          @showModalSubscribePlans="showModalSubscribePlans"
        />
        <div id="profileModel" class="block block--gray mt-1">
          <PerfilDescription :model="dataModel" :translate="translate" :divStyle="divStyle"/>          
          <div v-if="buttonShow" class="row d-flex align-items-center justify-content-center">
            <button type="button" class="more-profile mb-5 p-3 col-lg-3 col-8 z-1" @click="viewProfile">{{ translate.viewProfile }}
              <font-awesome-icon :icon="['fas', 'arrow-down']" size="md" /></button>
          </div>
          <BannerAssineHorizontal :path="banner" />
        </div>
      </tab-panel>
      <tab-panel :key="`tp1`" :val="2">
        <Videos
          v-if="dataModel?.shoot[0]?.videos.length && dataModel?.shoot[0]?.videos[0].name !== 'preview'"
          :model="dataModel"
          :translate="translate"
        />
        <VideosNotSubscribe
          v-else
          :model="dataModel"
          :translate="translate"
          @plans="(value) => showModalSubscribePlans(value)"
        />
        <div class="block block--gray">
          <BannerAssineHorizontal :path="banner" />
        </div>
      </tab-panel>
      <tab-panel :key="`tp1`" :val="6">
        <Lives
          v-if="dataModel?.shoot[0]?.lives.length > 1"
          :model="dataModel"
          :translate="translate"
        />
        <LivesNotSubscribe
          v-else
          :model="dataModel"
          :translate="translate"
          @plans="(value) => showModalSubscribePlans(value)"
        />
        <div class="block block--gray">
          <BannerAssineHorizontal :path="banner" />
        </div>
      </tab-panel>
      <tab-panel :key="`tp2`" :val="3">

      </tab-panel>
      <tab-panel :key="`tp2`" :val="4">
        <ModelWallpapers :model="dataModel" :translate="translate" />
        <div class="block block--gray mt-1">
          <BannerAssineHorizontal :path="banner" />
        </div>
      </tab-panel>
      <tab-panel :key="`tp2`" :val="5">
        <ModelCredits :model="dataModel" :translate="translate" />
        <div class="block block--gray">
          <BannerAssineHorizontal :path="banner" />
        </div>
      </tab-panel>
    </tab-panels>
  </div>
  <ModalSubscribePlans
    @showModalSubscribePlans="showModalSubscribePlans"
    :showSubscribe="showSubscribe"
    :plans="plans"
    v-if="plans"
    :translate="translate"
  />
</template>

<script lang="ts">
  import { isMobile } from 'views/shared/utils/mobile'
  import { defineComponent } from 'vue'
  import { mapState, mapActions } from 'pinia'
  import { localeStore } from 'stores/locale'
  import { planStore } from 'stores/plans'
  import { userStore } from 'stores/user'
  import translateModel from 'tradutors/model'
  import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs'
  import { event } from 'vue-gtag'
  import api from '../../api'
  import router from '../../router'
  export default defineComponent({
    name: 'NavBarHeader',
    components: {
      Tabs,
      Tab,
      TabPanels,
      TabPanel
    },
    props: ['model', 'banner'],
    computed: {
      ...mapState(localeStore, ['locale']),
      ...mapState(planStore, ['plans', 'languagePlans']),
      ...mapState(userStore, ['isActiveUser', 'user']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return translateModel.portugues
        } else {
          return translateModel.ingles
        }
      }
    },
    watch: {
      tabsHeader: function () {
        if (this.$route.params.complement) this.validOptionNavbarUrl()
        this.changeUrlTab(this.selectedTab)
      },
      dataModel: function () {
        if (this.dataModel?.shoot[0]?.lives && this.dataModel?.shoot[0]?.lives.length === 0) {
          let val = this.tabsHeader
          this.tabsHeader = val.filter((value) => value.name !== 'Lives')
        }
      },
      locale: function () {
        this.tabsHeader = this.translate.navBar
        this.getModel(this.model)
        this.getPlans()
      }
    },
    created() {
      this.tabsHeader = this.translate.navBar
      this.getModel(this.model)
      if (
        this.locale !== this.languagePlans ||
        this.$route.query.coupon ||
        this.$route.query.voucher
      )
        this.getPlans()
    },
    head() {
      return {
        templateParams: {
          subTitle: null,
          subPage: this.dataModel ? this.dataModel?.seoTitleModel : '',
          page_url: window.location.origin + this.$route.fullPath,
          page_description: this.dataModel
            ? this.dataModel.seoDescriptionModel ?? this.dataModel?.descriptionModel
            : '',
          page_image: this.dataModel ? this.dataModel?.imgPerfil : '',
          page_keywords: this.dataModel
            ? this.dataModel?.meta_keywords
            : 'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site, bella blog',
          page_locale: this.locale,
          page_url_pt:
            'https://belladasemana.com.br/pt-br/modelos/' +
            this.model +
            '/' +
            this.$route.params.complement,
          page_url_en:
            'https://belladasemana.com.br/en/modelos/' +
            this.model +
            '/' +
            this.$route.params.complement,
          page_canonical: 'https://belladasemana.com.br' + this.$route.fullPath
        }
      }
    },
    data() {
      return {
        selectedTab: 1,
        isMobile: isMobile(),
        tabsHeader: [],
        dataModel : null,
        showSubscribe: false,
        loading: true,
        divStyle: 'div-profile-hidden',
        buttonShow: true
      }
    },
    methods: {
      ...mapActions(planStore, ['setPlans', 'setCoupon', 'setVoucher', 'setCloseBanner']),
      getPlans() {
        api
          .get(
            `v1/home/getPlansFreeTour?language=${this.locale ?? ''}&coupon=${
              this.$route.query.coupon ?? ''
            }
            ${
              this.$route.query.voucher || this.voucher
                ? '&voucher=' + (this.$route.query.voucher ?? this.voucher)
                : ''
            }
            `
          )
          .then(({ data }) => {
            this.setPlans(data.plansFreeTour)
            this.setCoupon(this.$route.query.coupon ?? '')
            this.setCloseBanner(false)
            this.setVoucher(this.$route.query.voucher ?? '')
          })
      },
      showModalSubscribePlans(value) {
        if (!this.isActiveUser) {
          this.showSubscribe = value
          if (value == true)
            this.showModalPlans('Clicar para reproduzir o video sem ter uma assinatura ativa')
        }
      },
      showModalPlans(acionador: string) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'paywall',
          paywall: { acionador: acionador }
        })
        event('paywall2', { paywall: { acionador: acionador } })
      },
      getModel(nameModel: string) {
        this.loading = true
        let url = ''
        if (this.$route.query.preview == 'true') url = '&preview=true'
        api.get(`v1/modelos/${nameModel}?language=${this.locale ?? ''}${url}`).then(({ data }) => {
          this.dataModel = data
          if (isMobile()) {
            document.getElementById('header-optional').innerHTML =
              "<span style='font-size:25px;top:4px;left:-5px'> <a href='javascript:history.back()' class=''> <i class='icon-arrow-ios-left' style='color:black'></i> </a> </span>" +
              "<span style='left:-20px'>"+this.dataModel.nameModel.substr(0,17)+"</span>"
          }
          this.loading = false
        })
      },
      validOptionNavbarUrl() {
        switch (this.$route.params.complement) {
          case 'photo':
            this.selectedTab = 1
            break
          case 'video':
            this.selectedTab = 2
            break
          case 'live-videos':
            this.selectedTab = 6
            break
          case 'perfil':
            this.selectedTab = 3
            break
          case 'wallpaper':
            this.selectedTab = 4
            break
          case 'credits':
            this.selectedTab = 5
            break
          default:
            this.redirect('404')
            break
        }
      },
      redirect(name) {
        router.push({
          name,
          params: {
            locale: this.locale
          }
        })
      },
      changeUrlTab(event) {
        if (this.user && this.user.email) {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            event: 'user_id',
            user_id: {
              email: this.user.email
            }
          })
        }
        this.tabsHeader.forEach((element) => {
          if (event == 3) {
            this.selectedTab = 1            
            var newUrl =
              '/' +
              this.locale +
              '/modelos/' +
              router.currentRoute.value.params.name +
              '/photo'
              router.push(newUrl)              
              setTimeout(() => {
                document.getElementById("profileModel").scrollIntoView();
              }, 500)                      
          } else if (element.val == event) {
            var newUrl =
              '/' +
              this.locale +
              '/modelos/' +
              router.currentRoute.value.params.name +
              '/' +
              element.path
              router.push(newUrl)              
          }
          this.divStyle = 'div-profile-hidden'          
          this.buttonShow = true          
        })
      },
      viewProfile() {
        this.divStyle = 'div-profile-show'
        this.buttonShow = false
      },

    }
  })
</script>

<style scoped lang="css">
  .tabs {
    cursor: pointer;
    background-color: #f8f8f8;
  }

  .navbar-header-model >>> .tab {
    height: 64px;
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 61px;
    top: 5px;
  }

  .navbar-header-model .tabs > .active {
    border: 0px;
  }

  .navbar-header-model .tabs > .active::after {
    content: '';
    background: #b20000;
    position: absolute;
    left: 25%;
    width: 50%;
    height: 3px;
    bottom: 0px;
  }

  .tabs >>> .tab {
    padding: 0px 35px;
  }

  .tabs >>> .active .tab {
    color: #b20000;
    border-color: #b20000;
    font-weight: bold;
    font-family: 'Roboto-Bold';
  }

  .more-profile {
    font-weight: 500;
    background-color: black !important;
    border: 1px solid black !important;
    border-radius: 30px !important;
    color: white;
    font-family: "Exo-2";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }

  .more-profile svg {
    color: #b20;
    margin-left: 8px;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .tabs >>> .tab {
      padding: 0px 6px;
    }

    .navbar-header-model >>> .tab {
      font-size: 14px !important;
    }

    .tabs {
      margin-left: 0px;
    }

    :deep(.icon-arrow-ios-left::before) {
      background-color: #000000;
    }
  }
</style>
